/**
 * @param {vueInstance} context - This.
 * @returns {TableChart} The chart configuration object.
 */
export default function (context) {
  const { id } = context.item
  return {
    key: 'status_sold_residential',
    resource: {
      endpoint: 'status_sold_residential',
      filter: {
        'filter.statuses': ['sold'],
        'filter.limit': 10,
      },
    },
    type: 'Table',
    title: {
      id: 'status',
      label: `${context.$t('status')} ${context.$t('bid').toLowerCase()}`,
      icon: '',
      style: true,
    },
    // collapsible: {
    //   remove() {
    //     context.items = context.items
    //       .filter(item => !item.appended)
    //       .map(item => {
    //         delete item.toggled
    //         return item
    //       })
    //   },
    //   add({ item, rowIndex, data }) {
    //     const propertyId = item.propertyId

    //     const keyMap = {
    //       id: 'soldAt',
    //       priceTotal: 'priceTotal',
    //       type: 'propertyType',
    //     }

    //     const valueMap = {
    //       bid: context.$t('Enheten'),
    //       purchase: context.$t('Enheten'),
    //       shop: context.$t('Tilvalg'),
    //       soldAt: ({ contract }) => contract.id,
    //     }

    //     let nestedData = Object.entries(data.values)
    //       .flatMap(([key, value]) => {
    //         if (key === propertyId) return value
    //         return null
    //       })
    //       .filter(Boolean)

    //     if (rowIndex === 0) {
    //       nestedData = [...nestedData, { contract: { type: 'shop', priceTotal: 100, id: '12345' } }]
    //     }

    //     const tableNested = nestedData
    //       .map(d => {
    //         if (!d.contract) return null
    //         return Object.fromEntries(
    //           Object.entries(d.contract).map(([key, value]) => {
    //             const property = keyMap[key] || key
    //             const mappedValue = valueMap[value] || valueMap[property] || value

    //             return [property, typeof mappedValue === 'function' ? mappedValue(d) : mappedValue]
    //           }),
    //         )
    //       })
    //       .filter(Boolean)

    //     tableNested.map((v, index) => {
    //       context.items.splice(Number(rowIndex) + 1 + index, 0, {
    //         ...v,
    //         appended: true,
    //       })
    //     })

    //     const indexes = tableNested.map((v, i) => i + rowIndex + 1)

    //     context.items[rowIndex].toggled = true
    //     context.items = context.items
    //       .map((item, i) => {
    //         if (item.appended && !indexes.includes(i)) return
    //         if (item.toggled && i !== rowIndex) delete item.toggled
    //         return item
    //       })
    //       .filter(Boolean)
    //   },
    // },
    footer: {
      id: 'project_leads_footer',
      label: `${context.$t('showAll')} ${context.$t('bid').toLowerCase()}`,
      icon: ['fal', 'arrow-to-right'],
      component: 'router-link',
      props: {
        style: { textAlign: 'center', width: '100%' },
        theme: 'primary',
        to: {
          name: 'project-residentials',
          params: { id },
          query: { 'filter.status': 'sold' },
        },
      },
    },
    // cellWrapper: (item, col) => {
    //   return {
    //     component: 'div',
    //     props: { 'data-appended': item.appended },
    //   }
    // },
    // rowWrapper: ({ item, rowIndex, data, tableContext }) => {
    //   return {
    //     component: 'div',
    //   }
    // },
    actions: [
      {
        id: 'id_1',
        tooltip: 'residentialAccount',
        icon: ['fal', 'arrow-to-right'],
        to: ({ item = {} }) => {
          return {
            name: 'project-residentials',
            params: { id },
            query: {
              'filter.number': item.number,
              'filter.search': item.displayName,
            },
          }
        },
      },
    ],
    dimensions: [
      { key: 'property', type: 'string' },
      { key: 'groups' },
      { key: 'priceTotal', type: 'currency', align: 'end' },
      { key: 'soldAt', type: 'date' },
    ].map(dimension => ({
      id: dimension.key,
      label: context.getTranslation(dimension.key),
      icon: '',
      style: '',
      align: dimension.align || 'left',
      // component: ({ item = {} }) => {
      //   if (item.appended && dimension.key === 'soldAt')
      //     return {
      //       component: 'router-link',
      //       value: context.$t('se kontrakt'),
      //       props: {
      //         to: { name: 'contract', params: { id: item[dimension.key] } },
      //       },
      //     }
      //   return null
      // },
      value: ({ item = {} }) => {
        return context.valueParser(item[dimension.key], { type: dimension.type })
      },
    })),
    data: ({ data = {} }) => data.data,
  }
}
